import script from "./Policies.vue?vue&type=script&setup=true&lang=js"
export * from "./Policies.vue?vue&type=script&setup=true&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=f4449a1c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4449a1c"]])

export default __exports__